import { render, staticRenderFns } from "./IconPaymentLogos.vue?vue&type=template&id=1d0077bd"
import script from "./IconPaymentLogos.vue?vue&type=script&lang=js"
export * from "./IconPaymentLogos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports